export default "__VITE_ASSET__wIVCGR9D__"